import { Badge } from '@/shared/ui/badge'
import { Icon } from '@/shared/ui/icon'
import type { Company } from '../model/types'

interface CompanySummaryProps {
  company: Company
}

// Презентационная карточка строки списка. Навигацию (Link) навешивает страница —
// слой entities не знает роутер.
export function CompanySummary({ company }: CompanySummaryProps) {
  const secondary = [company.inn ? `ИНН ${company.inn}` : '', company.legal_name]
    .filter(Boolean)
    .join(' · ')

  return (
    <div className="flex items-center gap-3 rounded-card bg-bg-surface px-5 py-4 transition-colors hover:bg-bg-raised">
      <Icon name="building" size={18} className="shrink-0 text-text-tertiary" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate font-medium text-text-primary">{company.name}</span>
          {company.archived && <Badge tone="warning">В архиве</Badge>}
        </div>
        {secondary && <div className="mt-0.5 truncate text-xs text-text-tertiary">{secondary}</div>}
      </div>
      <Icon name="chevron-right" size={16} className="shrink-0 text-text-tertiary" />
    </div>
  )
}
